import types from './types';

const initialState = {
  meta: {
    fetchingSchedule: false,
    requestingTimeOff: false,
    requestTimeOffError: ''
  },
  shiftIds: [],
  shifts: [],
  timeOff: []
};

export const employeeScheduleReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_EMPLOYEE_SHIFTS_REQUEST: {
      return {
        ...state,
        meta: {
          ...state.meta,
          fetchingSchedule: true
        }
      };
    }
    case types.FETCH_EMPLOYEE_SHIFTS_SUCCESS: {
      let idsInStore = [...state.shiftIds];

      action.shifts.forEach(shift => {
        if (!idsInStore.includes(shift.id)) {
          idsInStore.push(shift.id);
        }
      });

      return {
        ...state,
        meta: {
          ...state.meta,
          fetchingSchedule: false
        },
        shiftIds: idsInStore,
        shifts: action.shifts,
        timeOff: action.timeOff
      };
    }
    case types.FETCH_EMPLOYEE_SHIFTS_FAILURE: {
      return {
        ...state,
        meta: {
          ...state.meta,
          fetchingSchedule: false
        }
      };
    }
    case types.REQUEST_TIME_OFF_REQUEST: {
      return {
        ...state,
        meta: {
          ...state.meta,
          requestingTimeOff: true,
          requestTimeOffError: ''
        }
      };
    }
    case types.REQUEST_TIME_OFF_SUCCESS: {
      return {
        ...state,
        meta: {
          ...state.meta,
          requestingTimeOff: false,
          requestTimeOffError: ''
        }
      };
    }
    case types.REQUEST_TIME_OFF_FAILURE: {
      return {
        ...state,
        meta: {
          ...state.meta,
          requestingTimeOff: false,
          requestTimeOffError: action.error
        }
      };
    }
    default:
      return state;
  }
};
